// Copyright 2025, University of Maryland, All Rights Reserved
import { createApiClient, buildUrl, type RequestOptions } from '@umd-dit-ai-workspace/api-client';

const API_URL = import.meta.env.VITE_API_URL;

// Create the shared API client instance
export const apiClient = createApiClient({
  baseURL: API_URL,
  debug: import.meta.env.NODE_ENV === 'development'
});

// Re-export the URL builder and types for compatibility
export { buildUrl, type RequestOptions };